import * as ko from 'knockout';

import { BaseTrialStep } from './base';
import { WizardController } from '../../screens/trial_wizard';
import { session } from '../../session';
import i18n from '../../i18n';

let template = require('raw-loader!../../../templates/components/trial_wizard/trial_visits.html').default;

class TrialVisits extends BaseTrialStep {
  // Read by the template (`data-bind="text: title"`), so it is not private — marking
  // it private only produced an unused-member error that a blanket @ts-ignore then
  // hid, along with a real null-safety error on the same line.
  title = session.isTreatmentManagementEnabledForTrial(this.trialWizard().trial())
    ? i18n.t('Step 8 - Scheduled visits')()
    : i18n.t('Step 7 - Scheduled visits')();

  loadingLibrary = ko.observable(false);

  private subscriptions: KnockoutSubscription[] = [];

  constructor(params: { controller: WizardController }) {
    super(params);
    this.ready(true);
  }

  async reload() {
    super.reload();

    this.dispose();
    this.subscriptions.push(this.trialWizard.subscribe(() => this.reload()));

    if (this.trialWizard().editMode === 'library') {
      this.loadingLibrary(true);
      await this.trialWizard().loadLibrarySV();
      this.loadingLibrary(false);
    }
  }

  dispose() {
    this.subscriptions.forEach((s) => s.dispose());
    this.subscriptions = [];
  }

  hasErrors() {
    for (let sv of this.trialWizard().scheduledVisits()) {
      if (sv.hasErrors()) {
        return true;
      }
    }

    return false;
  }

  showErrors() {
    for (let sv of this.trialWizard().scheduledVisits()) {
      sv.showErrors();
    }
  }

  applyLocalValidation() {
    return !this.hasErrors();
  }

  applyServerErrors(errors: any) {
    const svErrors = errors['scheduled_visits'] || [];
    // must match the payload order
    const svs = this.trialWizard().scheduledVisits();

    for (let i = 0; i < svErrors.length; i++) {
      const itemErrors = svErrors[i];
      if (!itemErrors || typeof itemErrors !== 'object' || !svs[i]) {
        continue;
      }
      this.applyModelServerErrors(svs[i], itemErrors);
    }
  }
}

ko.components.register('trial-visits', {
  viewModel: TrialVisits,
  template: template,
});
